import * as THREE from "three";
import { colors } from "./colors";

export function createCubeBox() {
  const geometry = new THREE.BoxGeometry(0.5, 0.5, 0.5);
  const material = new THREE.MeshBasicMaterial();
  const cube = new THREE.Mesh(geometry, material);

  setColor(cube, "white");

  cube.layers.set(1);

  return cube;
}

export function resetCube(mesh) {
  mesh.scale.set(1, 1, 1); // Reset scale to original size
}

export function setColor(object, color, lineWidth = 32) {
  if (!object) return;

  object.userData.previousColor = object.userData.color;
  object.userData.color = color;
  const texture = createTexture({ color, lineWidth });
  const material = new THREE.MeshBasicMaterial({ map: texture });
  object.material.dispose();
  object.material = material;
}

export function createTexture({
  color = "",
  lineColor = "black",
  lineWidth = 1,
} = {}) {
  const canvas = document.createElement("CANVAS");
  canvas.width = 512;
  canvas.height = 512;

  const context = canvas.getContext("2d");
  context.fillStyle = colors[color] || color;
  context.fillRect(0, 0, canvas.width, canvas.height);

  context.strokeStyle = colors[lineColor] || color;
  context.lineWidth = lineWidth;
  context.strokeRect(0, 0, canvas.width, canvas.height);

  const texture = new THREE.CanvasTexture(canvas);

  // tells THREE texture is in sRGB color space
  // so it converts it to linear space
  // three will convert sRGB values into linear,
  // perform calculations & convert it back to sRGB so it can be displayed on screen
  texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
}
